export enum MessageActionEnum {
  approve = 'approve',
  requestRevision = 'requestRevision',
  cancelRevision = 'cancelRevision',
  sendMessage = 'sendMessage',
}
